import React from "react";
import { tiers, features, footnote, footnoteCircle } from "./pricingData";
import { Feature, FeatureValue } from "./pricing";
import { Trans, useTranslation } from "react-i18next";

import "./PricingTable.scss";
import { ReactComponent as NoIcon } from "../../../../shared/assets/images/u_close.svg";
import { ReactComponent as CheckPurple } from "../../../../shared/assets/images/check-purple.svg";
import { ReactComponent as CheckGreen } from "../../../../shared/assets/images/check-green.svg";
export const PricingTable = () => {
  const { t } = useTranslation();
  const headerScrollRef = React.useRef<HTMLDivElement>(null);
  const tableScrollRef = React.useRef<HTMLDivElement>(null);

  const handleScroll =
    (source: "header" | "table") => (e: React.UIEvent<HTMLDivElement>) => {
      const scrollLeft = e.currentTarget.scrollLeft;
      if (source === "header" && tableScrollRef.current) {
        tableScrollRef.current.scrollLeft = scrollLeft;
      } else if (source === "table" && headerScrollRef.current) {
        headerScrollRef.current.scrollLeft = scrollLeft;
      }
    };

  const renderFeatureIcon = (value: FeatureValue, hasAsterisk?: boolean) => {
    if (value === "full") {
      return (
        <div className="icon-wrapper">
          <span className="icon check">
            <CheckGreen />
          </span>
          {hasAsterisk && <span className="asterisk">*</span>}
        </div>
      );
    }
    if (value === "limited") {
      return (
        <div className="icon-wrapper">
          <span className="icon limited">
            <CheckPurple />
          </span>
          {hasAsterisk && <span className="asterisk">*</span>}
        </div>
      );
    }
    return (
      <div className="icon-wrapper">
        <span className="icon none">
          <NoIcon />
        </span>
        {hasAsterisk && <span className="asterisk">*</span>}
      </div>
    );
  };

  return (
    <div className="pricing-table">
      <div className="table-section-title">
        <h2 className="title">{t("pages.Pricing.titles.comparePlans")}</h2>
        <div>
          <div className="subtitle">
            {t("pages.Pricing.titles.comparePlansSubtitle")}
          </div>
        </div>
      </div>
      <div className="pricing-table-wrapper" style={{ marginTop: 60 }}>
        {/* Header: só os nomes dos planos */}
        <div className="header-sticky">
          <div
            className="header-scroll"
            ref={headerScrollRef}
            onScroll={handleScroll("header")}
          >
            <div className="header">
              <div className="feature-column">
                <span className="body-large">Features</span>
              </div>
              {tiers.map((tier) => (
                <div key={tier.id} className="tier">
                  <h3 className="tier-name">{tier.name}</h3>
                  <p className="tier-subtitle">
                    <Trans
                      i18nKey={t(tier.subtitle)}
                      components={{ span: <span className="green-color" /> }}
                    />
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className="table-scroll"
          ref={tableScrollRef}
          onScroll={handleScroll("table")}
        >
          <div className="table">
            {/* PRIMEIRA ROW: Soporte (com texto, não ícone) */}
            <div className="row support">
              <div className="feature-name">
                {t("pages.Pricing.features.support")}
              </div>
              {tiers.map((tier) => (
                <div key={tier.id} className="cell">
                  {tier.support}
                </div>
              ))}
            </div>
            {/* Resto das features (com ícones) */}
            {features.map((feature: Feature) => (
              <div key={feature.id} className="row">
                <div className="feature-name">{t(feature.labelKey)}</div>
                {tiers.map((tier) => (
                  <div key={tier.id} className="cell">
                    {renderFeatureIcon(
                      feature.availability[tier.id],
                      feature.hasAsterisk
                    )}
                  </div>
                ))}
              </div>
            ))}
            <div className="footnote">
              <CheckPurple />{" "}
              <span style={{ color: "hsla(260, 100%, 70%, 1)" }}>
                {t(footnoteCircle)}
              </span>{" "}
              <span style={{ marginLeft: "20px" }}>* {t(footnote)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
